import { Pipe, PipeTransform } from '@angular/core';
import { CommentModel, isSystemComment } from '@dta/shared/models-api-loop/comment/comment.model';

@Pipe({
  name: 'isSystemComment',
  standalone: false
})
export class IsSystemCommentPipe implements PipeTransform {
  transform(comment?: CommentModel): boolean {
    return comment && isSystemComment(comment);
  }
}
